import PropTypes from 'prop-types';
import React, {useContext, useEffect, useState} from 'react';

import Select, {SelectItem} from '../ui/Select';
import ApplicationContext from "../ApplicationContext";
import {MultiName} from "../fms.core/constants";

interface IMultiName {
  intValue: number;
  text: string;
}

function MultiNameDropDown({
  value,
  onChange = () => {
  },
  disabled = false,
  selectId,
  loadFromConfig = false,
  name = undefined,
  maxLength = undefined,
}: {
  value: string | null | undefined,
  disabled?: boolean,
  onChange?: (x: IMultiName | null) => void,
  selectId?: string,
  loadFromConfig?: boolean,
  name?: string | undefined,
  maxLength?: number|undefined,
}) {
  const appContext = useContext(ApplicationContext);

  const [data, setData] = useState<Array<IMultiName>>([]);

  async function fetchData(api: any) {
    const data = await api.loadCodeData([new MultiName()]);
    if (data && data.length > 0) {
      setData(data[0].items);
      if(loadFromConfig) {
        if(appContext.systemSettings?.useMultipleNames && data[0].items.length > 0) {
          if(data[0].items[0]) {
            onChange(data[0].items[0] || null);
          } else if(data[0].items.length > 1) {
            onChange(data[0].items[1] || null);
          }
        } else if(!appContext.systemSettings?.useMultipleNames && data[0].items.length > 0) {
          if(data[0].items[0])
            onChange(data[0].items[0] || null);
        }
      }
    }
  }

  useEffect(() => {
      fetchData(appContext.api);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    if (e.target.value === undefined) {
      onChange(null);
      return;
    }
    onChange(data?.find(d => d.intValue.toString() === e.target.value.toString()) || null);
  }

  const displayData: Array<SelectItem> = [
    ...data.map(x => ({value: x.intValue ?? '', label: x.text ?? ''}))
  ];

  return (
    <Select
      maxLength={maxLength}
      name={name}
      selectId={selectId}
      value={(value === null || value === undefined) ? '' : value}
      onChange={handleChange}
      disabled={disabled}
      items={displayData}
    />
  );
}

MultiNameDropDown.defaultProps = {
  onChange: () => {
  },
  disabled: false,
  dark: false
};

MultiNameDropDown.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  dark: PropTypes.bool.isRequired,
  selectId: PropTypes.string
};

export default React.memo(MultiNameDropDown);
